module.exports = __webpack_public_path__ + "img/Teamviewer.cd682cb4.svg";